import axios from "./axios.config"
export const imageBaseURL=`https://app.jntuweb.com`;
// export const imageBaseURL="http://localhost:1337";
export async function fetchData(url,setData){
    const {data} = await axios.get(url)
    setData(data)
    return null
};
